// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__LxvrD","file":"styles_file__2VkMQ"};